// src/api/productApi.js

import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/helpers/axiosInstance';

export const fetchProductById = createAsyncThunk(
  'product/fetchById',
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/products/get-product-by-id/${productId}`);
      const product = response?.data?.data;
      return { productId, product };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Something went wrong, While fetching product info' }
      );
    }
  }
);


